import { createContext } from 'react'


export type Error = Readonly<{
  time: number
  text: string
  response?: Response
  params?: any
}>

type TimeoutError = boolean

export type ErrorsQueue = ReadonlyArray<Error>
export type ErrorActions = Readonly<{
  throwError: (text: string, response?: Response, params?: any) => void
  throwTimeoutError: () => void
  clearErrors: () => void
  resetApp: () => void
  resetTimeoutError: () => void
}>

export type Context = [ErrorsQueue, ErrorActions, TimeoutError]

const defaultContext: Context = [[], {
  throwError: () => {},
  throwTimeoutError: () => {},
  clearErrors: () => {},
  resetApp: () => {},
  resetTimeoutError: () => {},
}, false]

export default createContext(defaultContext)
